import React from "react";
import { XIcon } from "@heroicons/react/outline";
import { Popover, Transition } from "@headlessui/react";
import { ChromePicker, ColorResult } from "react-color";
import { Float } from '@headlessui-float/react'
import { isEmpty } from "lodash";

type InputProps = {
  placeholder?: string;
  id?: string;
  label?: string;
  error?: any;
  type?: string;
  isClearable?: boolean;
  [x: string]: any;
};

const ColorPicker = React.forwardRef((props: InputProps, ref: any) => {
  return (
    <Popover className="relative">
      {(props.value && props.isClearable) ? (
        <button 
          type="button"
          className="absolute top-1/2 right-4 transform -translate-y-1/2 z-1" 
          onClick={() => props.onChange("")}
        >
          <span className="sr-only">Clear color</span>
          <XIcon className="w-4 h-4 text-gray-900" aria-hidden="true" />
        </button>
      ) : <></>}
      <Float flip>
        <Popover.Button className="input text-left border border-gray-300 cursor-pointer outline-none">
          {isEmpty(props.value) ? <p className="text-[#a9a9a9]">{props.placeholder ?? "Choose a color"}</p> : (
            <div className="flex items-center gap-x-3 uppercase">
              <div 
                className="w-6 h-6 rounded-md border-1 border-solid border-black" 
                style={{backgroundColor: props.value}}
              /> 
              {props.value}
            </div>
          )}          
        </Popover.Button>
        <Transition
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Popover.Panel className="w-fit my-2">
            <div className="w-fit">
              <ChromePicker
                disableAlpha
                onChange={(color: ColorResult) => props.onChange(color.hex)}
                color={props.value} className="mt-2"
              />
            </div>
          </Popover.Panel>
        </Transition>
      </Float>
    </Popover>
  )
});

ColorPicker.displayName = "ColorPicker";

export default ColorPicker;
